export function spaceTextByUpperCase(text: string) {
  return text.replace(/([a-z])(?=[A-Z])|([A-Z])(?=[A-Z][a-z])/g, '$1$2 ');
}
